import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import LicenseesPage from "./pages/LicenseesPage";
import LicensorsPage from "./pages/LicensorsPage";
import AboutEgeezPage from "./pages/AboutEgeezPage";
import NotesPage from "./pages/NotesPage";
import ResearchPage from "./pages/ResearchPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfUse from "./pages/TermsOfUse";
import RefundPolicy from "./pages/RefundPolicy";
import PlaceholderPage from "./pages/PlaceholderPage";
import GleapBubble from "./components/GleapBubble";

// Send a GA4 page_view on every SPA route change
function GAPageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);
  return null;
}

// Scroll-to-top on every route change so legal pages always start at the top
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <GAPageTracker />
        <ScrollToTop />
        <GleapBubble />
        <Routes>
          {/* Standalone legal pages — minimal layout, no main nav/ticker */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />

          {/* Marketing pages share the main Layout (NewsTicker + NavBar + Footer) */}
          <Route
            path="*"
            element={
              <Layout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/for-fans" element={<Home />} />
                  <Route path="/for-licensees" element={<LicenseesPage />} />
                  <Route path="/for-licensors" element={<LicensorsPage />} />
                  <Route path="/about-egeez" element={<AboutEgeezPage />} />
                  <Route path="/notes" element={<NotesPage />} />
                  <Route path="/research" element={<ResearchPage />} />
                  <Route
                    path="*"
                    element={
                      <PlaceholderPage
                        title="404"
                        subtitle="The page you're looking for doesn't exist (yet)."
                        ctaLabel="Back to Home"
                        ctaUrl="/"
                      />
                    }
                  />
                </Routes>
              </Layout>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
